// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Util_Array = require("../util/Util_Array.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");

function reducer(state, action) {
  if (typeof action !== "number") {
    return action._0;
  }
  switch (action) {
    case /* SetOn */0 :
        return {
                TAG: /* Changed */1,
                _0: /* On */0
              };
    case /* SetOff */1 :
        return {
                TAG: /* Changed */1,
                _0: /* Off */1
              };
    case /* Toggle */2 :
        if (state._0) {
          return {
                  TAG: /* Changed */1,
                  _0: /* On */0
                };
        } else {
          return {
                  TAG: /* Changed */1,
                  _0: /* Off */1
                };
        }
    
  }
}

function toStatus($$boolean) {
  if ($$boolean) {
    return /* On */0;
  } else {
    return /* Off */1;
  }
}

function fromStatus(status) {
  if (status) {
    return false;
  } else {
    return true;
  }
}

function make(statusOpt, onOnOpt, onOffOpt, param) {
  var status = statusOpt !== undefined ? statusOpt : /* Off */1;
  var onOn = onOnOpt !== undefined ? onOnOpt : (function (param) {
        
      });
  var onOff = onOffOpt !== undefined ? onOffOpt : (function (param) {
        
      });
  var match = React.useReducer(reducer, {
        TAG: /* Pristine */0,
        _0: status
      });
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          Curry._1(dispatch, /* Set */{
                _0: {
                  TAG: /* Pristine */0,
                  _0: status
                }
              });
        }), [status]);
  React.useEffect((function () {
          if (state.TAG !== /* Pristine */0) {
            if (state._0) {
              Curry._1(onOff, undefined);
            } else {
              Curry._1(onOn, undefined);
            }
          }
          
        }), [state]);
  var toggleRaw = function (param) {
    Curry._1(dispatch, /* Toggle */2);
  };
  var toggle = function (param) {
    Curry._1(dispatch, /* Toggle */2);
  };
  var close = function (param) {
    Curry._1(dispatch, /* SetOff */1);
  };
  var stateBoolean = state._0 ? false : true;
  return {
          toggleRaw: toggleRaw,
          toggle: toggle,
          state: state._0,
          stateBoolean: stateBoolean,
          close: close,
          setOn: (function (param) {
              Curry._1(dispatch, /* SetOn */0);
            })
        };
}

function getSelecteds(arr) {
  return Util_Array.NonEmpty.keep(arr, (function (param) {
                if (param.status) {
                  return false;
                } else {
                  return true;
                }
              }));
}

function getGlobalStatus(values) {
  return Belt_Option.mapWithDefault(getSelecteds(values), /* NoOne */0, (function (selecteds) {
                if (Util_Array.NonEmpty.length(selecteds) === Util_Array.NonEmpty.length(values)) {
                  return {
                          TAG: /* All */0,
                          _0: Util_Array.NonEmpty.map(selecteds, (function (param) {
                                  return param.key;
                                }))
                        };
                } else {
                  return {
                          TAG: /* Selected */1,
                          _0: Util_Array.NonEmpty.map(selecteds, (function (param) {
                                  return param.key;
                                }))
                        };
                }
              }));
}

function reducer$1(state, action) {
  if (typeof action === "number") {
    if (action !== 0) {
      return {
              values: Util_Array.NonEmpty.map(state.values, (function (value) {
                      return {
                              key: value.key,
                              status: /* On */0,
                              data: value.data
                            };
                    })),
              selecteds: {
                TAG: /* All */0,
                _0: Util_Array.NonEmpty.map(state.values, (function (param) {
                        return param.key;
                      }))
              },
              formState: /* Changed */1
            };
    } else {
      return {
              values: Util_Array.NonEmpty.map(state.values, (function (value) {
                      return {
                              key: value.key,
                              status: /* Off */1,
                              data: value.data
                            };
                    })),
              selecteds: /* NoOne */0,
              formState: /* Changed */1
            };
    }
  }
  var key = action._0;
  var values = Util_Array.NonEmpty.map(state.values, (function (value) {
          if (key !== value.key) {
            return value;
          }
          var match = value.status;
          return {
                  key: value.key,
                  status: match ? /* On */0 : /* Off */1,
                  data: value.data
                };
        }));
  var globalStatus = getGlobalStatus(values);
  return {
          values: values,
          selecteds: globalStatus,
          formState: /* Changed */1
        };
}

function makeInitialState(entries, getKey) {
  var entries$1 = Util_Array.NonEmpty.map(entries, (function (entry) {
          return {
                  key: Curry._1(getKey, entry.data),
                  status: entry.status,
                  data: entry.data
                };
        }));
  var globalStatus = getGlobalStatus(entries$1);
  return {
          values: entries$1,
          selecteds: globalStatus,
          formState: /* Pristine */0
        };
}

function make$1(onChange, getKey, entries) {
  var initialState = React.useMemo((function () {
          return makeInitialState(entries, getKey);
        }), [
        getKey,
        entries
      ]);
  var match = React.useReducer(reducer$1, initialState);
  var dispatch = match[1];
  var state = match[0];
  var setAllOff = React.useCallback((function (param) {
          Curry._1(dispatch, /* SetAllOff */0);
        }), [state]);
  var setAllOn = React.useCallback((function (param) {
          Curry._1(dispatch, /* SetAllOn */1);
        }), [state]);
  var toggle = function (key, param) {
    Curry._1(dispatch, /* Toggle */{
          _0: key
        });
  };
  React.useEffect((function () {
          var match = state.formState;
          if (match && onChange !== undefined) {
            Curry._1(onChange, state.selecteds);
          }
          
        }), [
        state.selecteds,
        onChange,
        state.formState
      ]);
  return {
          status: state.selecteds,
          values: Util_Array.NonEmpty.toArray(state.values),
          setAllOn: setAllOn,
          setAllOff: setAllOff,
          toggle: toggle
        };
}

var Multiple = {
  getSelecteds: getSelecteds,
  getGlobalStatus: getGlobalStatus,
  reducer: reducer$1,
  makeInitialState: makeInitialState,
  make: make$1
};

exports.reducer = reducer;
exports.toStatus = toStatus;
exports.fromStatus = fromStatus;
exports.make = make;
exports.Multiple = Multiple;
/* react Not a pure module */
